// キャンバス名の表示用正規化。
// 旧スキーマで「未保存のキャンバス」として保存された既存レコードや、
// 空文字のタイトルを「無題のキャンバス」へ揃える。

export const DEFAULT_CANVAS_TITLE = "無題のキャンバス";

const LEGACY_DEFAULT_TITLES: ReadonlySet<string> = new Set(["未保存のキャンバス"]);

export function normalizeCanvasTitle(title: string | null | undefined): string {
  if (title == null) return DEFAULT_CANVAS_TITLE;
  const trimmed = title.trim();
  if (trimmed.length === 0) return DEFAULT_CANVAS_TITLE;
  if (LEGACY_DEFAULT_TITLES.has(trimmed)) return DEFAULT_CANVAS_TITLE;
  return trimmed;
}
